import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { CookiesService } from '../../services/cookies.service';
import { Meta } from '@angular/platform-browser';

@Component({
    selector: 'app-politica-de-cookies',
    imports: [],
    templateUrl: './politica-de-cookies.component.html',
    styleUrl: './politica-de-cookies.component.css'
})
export class PoliticaDeCookiesComponent implements OnInit {

  constructor(
    @Inject(PLATFORM_ID) private readonly platformId: object,
    private readonly cookiesServiceManual: CookiesService,
    private readonly meta: Meta
  ) {}

  ngOnInit(): void {
    this.meta.addTag({ name: 'description', content: 'Conoce la política de cookies de Centralgas de grupo Sunflower Energías. Descubre cómo utilizamos cookies para mejorar la experiencia de usuario, personalizar contenido y analizar el uso de nuestro sitio web' });
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    const chkPersonalizacion = document.getElementById("chkCPState") as HTMLInputElement;
    const chkAnalitica = document.getElementById("chkCAState") as HTMLInputElement;
  

    if (chkPersonalizacion) {
      chkPersonalizacion.checked = this.cookiesServiceManual.personalizacionAceptada();
    }
  
    if (chkAnalitica) {
      chkAnalitica.checked = this.cookiesServiceManual.analiticaAceptada();
    }


    // Si no se aceptaron las cookies personalizadas, mostramos la barra de aceptación
    if (!this.cookiesServiceManual.personalizacionAceptada()) {
      this.cookiesServiceManual.mostrarBarraAceptacion(true);
    }

    // Si ya se aceptaron las cookies analíticas, activa la funcionalidad de Google Analytics
    if (this.cookiesServiceManual.analiticaAceptada()) {
     
      if (chkAnalitica) {
        chkAnalitica.checked = this.cookiesServiceManual.analiticaAceptada();
      }
    }
  }

  onAnaliticaStateChange(event: Event): void {
    this.cookiesServiceManual.analiticaStateChange(event);
  }


  onPersonalizacionStateChange(event: Event): void {
    this.cookiesServiceManual.personalizacionStateChange(event);
  }
  

}
